import { useState } from "react";

type SetStateAction<S> = S | ((prevState: S) => S);
type Dispatch<A> = (value: A) => void;

export default function useControlledState<R>(
  initial: R,
  parentParam?: R,
  onChange?: (value: R) => void
): [R, Dispatch<SetStateAction<R>>] {
  const [param, setParam] = useState<R>(initial);

  const controlledParam = parentParam !== undefined ? parentParam : param;

  const setControlledParam: Dispatch<SetStateAction<R>> = (value) => {
    const newValue: R =
      typeof value === "function" ? (value as (prevState: R) => R)(controlledParam) : value;

    setParam(newValue);
    onChange && onChange(newValue);
  };

  return [controlledParam, setControlledParam];
}
